import React, { Component, useState } from 'react';
import { Link } from 'react-router-dom'
import Breadcrumb from "../common/breadcrumb";
import { LoginApi } from '../../services/api.js'
import { Helmet } from 'react-helmet';
import Pace from 'react-pace-progress'
import TopBarProgress from "react-topbar-progress-indicator";

TopBarProgress.config({
    barColors: {
        "0": "#ed1717",
        "1.0": "#ed1717"
    },
    shadowBlur: 5
});
class Login extends Component {

    constructor(props) {
        super(props)
    }
    state = {
        userName: '',
        password: '',
        callback: null,
        loading: false
    }
    componentDidMount() {
        const searchParams = new URLSearchParams(this.props.location.search);
        let callback = searchParams.get('callback');
        this.setState(state => ({ ...state, callback }));
    };

    submit = async () => {
        this.setState(state => ({ ...state, loading: true }));
        let payload = {
            username: this.state.userName,
            password: this.state.password
        }
        await LoginApi(payload, this.state.callback);
        this.setState(state => ({ ...state, loading: false }));
    }

    render() {


        return (
            <div>
                {/* <Breadcrumb title={'ورود'} /> */}

                <Helmet>
                    <title>ایزی کارت 724 | ورود</title>
                    <meta name="description" content="Multikart – Multipurpose eCommerce React Template is a multi-use React template. It is designed to go well with multi-purpose websites. Multikart Bootstrap 4 Template will help you run multiple businesses." />
                </Helmet>
                {this.state.loading && <TopBarProgress />

                }
                {/*Login section*/}
                <section className="login-page section-b-space">
                    <div className="container">
                        <div className="row" style={{ justifyContent: 'center' }}>
                            <div className="col-lg-6">

                                <div className="theme-card">
                                    <form className="theme-form">
                                        <div className="form-group"> <h3 className="text-center">ورود</h3>
                                            <label htmlFor="email">نام کاربری</label>
                                            <input type="text" value={this.state.userName} onChange={(e) => this.setState({ userName: e.target.value })} className="form-control" id="userName" placeholder="نام کاربری خود را وارد کنید"
                                                required="" />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="review">رمز عبور</label>
                                            <input type="password" value={this.state.password} onChange={(e) => this.setState({ password: e.target.value })} className="form-control" id="password"
                                                placeholder="رمز عبور خود را وارد کنید" required="" />
                                        </div>
                                        <Link to="/pages/forget-password">
                                        <h6 style={{color: '#cc0202'}}><i className="fa fa-info-circle" style={{ color: '#cc0202' }}></i> فراموشی رمز عبور</h6></Link>

                                    </form>
                                    <div className="text-center">
                                        <button className="btn btn-solid " onClick={this.submit}>تایید</button>

                                    </div> <div className="text-center">
                                        <Link to={!this.state.callback ? "/pages/register" : "/pages/register?callback=" + this.state.callback}>
                                            <div className="btn btn-primary p-3 mt-3">حساب کاربری ندارید؟ ثبت نام کنید</div>
                                        </Link>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </section>

            </div>
        )
    }
}

export default Login